import { isNil, omitBy } from 'lodash';

export function cleanNilValues(object) {
  return omitBy(object, isNil);
}
